module.exports = __webpack_public_path__ + "static/media/wf.5d5da639.svg";